/**
 * Triage dialog — order of work over the product versions (pure, React-free).
 */
import type { ProductAssessmentRow } from '../../lib/types';

/**
 * The next version after *current* still waiting for its verdict to be
 * confirmed or reviewed, in list order and wrapping around (DEV-103).
 */
export function nextOpenProduct(
  products: readonly Pick<ProductAssessmentRow, 'version_id' | 'confirmed' | 'needs_review'>[], current: number,
): number | null {
  const index = products.findIndex((p) => p.version_id === current);
  const ordered = [...products.slice(index + 1), ...products.slice(0, Math.max(index, 0))];
  return ordered.find((p) => !p.confirmed || p.needs_review)?.version_id ?? null;
}
